import registerTilelistLoadingEvent, { emergencyRemoveChatbotBanner } from "./tilelist/TilelistLoading";
import { registerTileLoading } from "./tilelist/TileLoading";
import { registerFirebase } from "./tracking/Firebase";
import { eventQBus } from "./types/EventQBus";
import { invokePreloadPolyfill } from "./utils/Dom";
import { addSortEventListenerToElements } from "./tilelist/Sort";
import { initComparisonAndSheet } from "./comparison/Comparison";
import { registerTileScrolling } from "./tilelist/ScrollTracking";
import { registerProductTileClickHandling } from "./tilelist/ProductTileClickHandling";
import { registerPaging } from "./tilelist/Paging";
import { registerTileListHistory } from "./tilelist/TilelistHistory";
import { registerExacTag } from "./tilelist/ExacTag";
import { registerTilelistCache } from "./tilelist/TilelistCache";
import { eventLoader } from "@otto-ec/global-resources/event-loader";
import {
  registerProductComparisonBanner,
  registerProductComparisonCookieCheck,
} from "./tilelist/ProductComparisonBanner";
import RatingSlider from "./tilelist/slider/RatingSlider";
import { registerSponsored } from "./sponsored/SponsoredSheetHandler";
import { registerDiscountBenefitSheet } from "./tilelist/DiscountBenefitHandler";
import BrandSlider from "./tilelist/slider/BrandSlider";

eventLoader.onReady(2, () => {
  const ratingSlider = new RatingSlider();
  const brandSlider = new BrandSlider();

  registerTileListHistory();
  registerTilelistLoadingEvent();
  addSortEventListenerToElements();
  registerPaging();
  registerTilelistCache(undefined);
  ratingSlider.registerSlider();
  brandSlider.registerSlider();

  eventQBus.on("ftfind.tilelist.loaded", addSortEventListenerToElements);
  /*                       */
  eventQBus.on("ftfind.tilelist.loaded", invokePreloadPolyfill);
  eventQBus.on("ftfind.tilelist.loaded", registerTilelistCache);
});

eventLoader.onReady(9, () => {
  initComparisonAndSheet();
  registerDiscountBenefitSheet();
  registerFirebase();
  registerExacTag();
});

eventLoader.onReady(11, () => {
  registerProductTileClickHandling();
  registerSponsored();
  registerProductComparisonCookieCheck();
  registerProductComparisonBanner();
});

eventLoader.onReady(99, () => {
  registerTileLoading();
  registerTileScrolling();
  emergencyRemoveChatbotBanner();
});
